<template>
  <el-cascader
    v-if="show"
    v-model="selected"
    filterable
    :options="options"
    :props="props"
    collapse-tags
    clearable
    style="width: 100%"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      props: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      },
    };
  },
  computed: {
    options() {
      return Array.isArray(this.data) ? this.data : [];
    },
    selected: {
      get() {
        // если получили объекты, возвращаем id
        if (Array.isArray(this.value) && typeof this.value[0] === "object") {
          return this.value.map((e) => e.id);
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    setTimeout(() => {
      // откладываем тяжелый рендеринг компонента, даем время загрузиться контенту
      this.show = true;
    }, 300);
  },
};
</script>
